import IconButton from "@pathwright/ui/src/components/button/IconButton"
import useIntersection from "@pathwright/ui/src/components/hooks/useIntersection"
import { useUserCompletionsNeedingReviewQuery } from "../../api/generated"

const UserCompletionsNeedingReview = ({ userId }: { userId: number }) => {
  // Using useIntersection for query optimization.
  const [setIntersectionNode, intersection, hasIntersected] = useIntersection()

  const userCompletionsNeedingReviewQuery =
    useUserCompletionsNeedingReviewQuery({
      variables: {
        user_id: userId
      },
      skip: !hasIntersected
    })

  const { loading } = userCompletionsNeedingReviewQuery
  const count =
    userCompletionsNeedingReviewQuery.data?.pathItemStats
      ?.path_items_needing_review || 0

  return (
    <div ref={setIntersectionNode}>
      <IconButton
        interactive={!loading}
        to={{
          pathname: `/completion/`,
          query: {
            user_id: userId,
            ...(count > 0 ? { filter: "needs_review" } : {})
          },
          state: { setLaunchedFrom: true }
        }}
        styleType="tertiary"
        icon="inbox"
        countIndicatorProps={
          count && {
            count
          }
        }
      />
    </div>
  )
}

UserCompletionsNeedingReview.displayName = "UserCompletionsNeedingReview"

export default UserCompletionsNeedingReview
